import React, {useState} from 'react';
import PropTypes from 'prop-types';
import IconIncorrect from '@learningblocks/exp-constants/lib/Images/incorrect-feedback-icon.svg';
import {Image} from '@learningblocks/storybook-components';
import './style.scss';

/**
 * Tooltip Component:
 *  - Typically used to display error messages.
 */
export function Tooltip({title, children}) {
  const [hover, setHover] = useState(false);

  const onMouseOver = () => setHover(true);

  const onMouseOut = () => setHover(false);

  const renderTooltip = () => (
    <div className='tooltip'>
      <div className='tooltip-icon'>
        <Image src={IconIncorrect} alt='icon-incorrect' />
      </div>
      <div className='tooltip-text'>
        <p>{title}</p>
      </div>
    </div>
  );

  const renderTooltipContent = () => {
    if (hover && title) return renderTooltip();
    else return null;
  };

  return (
    <span
      className='tooltip-wrap'
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}>
      {children}
      {renderTooltipContent()}
    </span>
  );
}

Tooltip.propTypes = {
  /**
   * Child element to be displayed inside the Modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Title string for the Modal.
   */
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

Tooltip.defaultProps = {
  title: '',
};
